// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Ez4ul","desc":"styles_desc__vIAyk","top-card":"styles_top-card__jCGsH"};